import type { IntlShape } from "react-intl";

export const fieldsLabels = {
  vehicleId: "ID do Veículo",
  vehicleChassis: "Chassi",
  vehicleModel: "Modelo do Veículo",
  vehicleLicensePlate: "Placa",
  vehicleType: "Tipo de Veículo",
  vehicleName: "Nome do Veículo",
  vehicleYear: "Ano do Veículo",
  vehicleSaleDate: "Data de Venda do Veículo",
  vehicleOdometer: "Odômetro",
  vehicleHourmeter: "Horômetro",
  vehiclePayloadType: "Carga",
  vehicleMaximumPayload: "Peso da carga",
  vehicleCriticalPayload: "Carga Crítica",
  vehicleStopped: "Unidade Parada",

  driverName: "Nome do Motorista",
  driverLicenseNumber: "CNH do Motorista",
  driverPhone: "Telefone do Motorista",
  driverCheckInDriver: "Localização do Motorista",

  dealershipName: "Nome da Concessionária",
  dealershipDn: "DN da Concessionária",
  dealershipUniqueId: "CNPJ da Concessionária",
  dealershipLocation: "Localização da Concessionária",
  dealershipRepresentative: "Representante da Concessionária",
  dealershipRegional: "Regional da Concessionária",
  dealershipPhone: "Telefone da Concessionária",
  dealershipDemarcatedArea: "Área Demarcada da Concessionária",

  partOrders: "Pedidos de Peças",
  partOrderParts: "Peças",
  partOrder: "Pedido de Peças",
  partOrderDtOrder: "Data do Pedido de Peças",
  partOrderDtEstimate: "Data da Previsão de Entrega",
  partOrderDtDeliveryEstimate: "Data de Entrega da Peça",
  partOrderStatus: "Status Peças",
  partOrderNumber: "Número do Pedido de Peças",
  partOrderStatusOrder: "Status do Pedido de Peças",
  partOrderDeliveryDates: "Datas de Entrega do Pedido de Peças",

  criticality: "Criticidade",
  osNumber: "Número da OS",
  osDtOpenAt: "Data de Abertura da OS",
  createdBy: "Criado por",
  literatureDiagnosis: "Leitura de Diagnóstico",
  literatureTroubleshooting: "Literatura para Troubleshooting",
  country: "País",
  occurrenceType: "Tipo de Ocorrência",
  tasNumber: "Número TAS",
  tasStatus: "Status TAS",
  timeOpenProtocol: "Tempo para Abertura do Protocolo",
  source: "Origem",
  hasLink: "Possui Vínculo",
  mainOccurrence: "Ocorrência Principal",
  estimateTimeRepair: "Tempo Estimado de Reparo",
  solutionProposed: "Reparo/Solução Dada",
  mechanicLocation: "Localização do Mecânico",
  towTruckLocation: "Localização do Guincho",
  checklist: "Checklist",
  customer: "Cliente",
  renter: "Locatário",
  emissionStandard: "Legislação",
  protocolNumber: "Número do Protocolo",
  scheduleNumber: "UUID do Agendamento",
  failureType: "Tipo de Falha",
};

export const fieldsWorklogLabels = {
  currentStep: "Etapa Atual",
  criticality: "Criticidade",
  osNumber: "Número da OS",
  osDtOpenAt: "Data de Abertura da OS",
  renter: "Locatário",
  literatureTroubleshooting: "Literatura para Troubleshooting",
  occurrenceType: "Tipo de Ocorrência",
  tasNumber: "Número TAS",
  tasStatus: "Status TAS",
  timeOpenProtocol: "Tempo para Abertura do Protocolo",
  source: "Origem",
  hasLink: "Possui Vínculo",
  observation: "Observação",
  status: "Status",
  mainOccurrence: "Ocorrência Principal",
  estimateTimeRepair: "Tempo Estimado de Reparo",
  solutionProposed: "Reparo/Solução Dada",
  mechanicLocation: "Localização do Mecânico",
  towTruckLocation: "Localização do Guincho",
  checklist: "Checklist",
  customer: "Cliente",
  protocolNumber: "Número do Protocolo",
  partnerId: "ID do Parceiro",
  hasCampaigns: "Possui Campanhas",
  finalizationReasonType: "Tipo de Motivo de Finalização",
  finalizationReasonDescription: "Descrição do Motivo de Finalização",

  // Campos do veículo
  vehicleChassis: "Chassi",
  vehicleModel: "Modelo do Veículo",
  vehicleLicensePlate: "Placa",
  vehicleVehicleType: "Tipo de Veículo",
  vehicleName: "Nome do Veículo",
  vehicleVehicleYear: "Ano do Veículo",
  vehicleOdometer: "Odômetro",
  vehicleHourMeter: "Horômetro",
  vehicleEmissionStandard: "Legislação",
  vehiclePayloadType: "Carga",
  vehicleMaximumPayload: "Peso da carga",
  vehicleCriticalPayload: "Carga Crítica",
  vehicleStopped: "Unidade Parada",

  // Campos do motorista
  driverName: "Nome do Motorista",
  driverLicenseNumber: "CNH do Motorista",
  driverPhone: "Telefone do Motorista",
  driverCheckInDriver: "Localização do Motorista",

  // Campos da concessionária
  dealershipDn: "DN da Concessionária",
  dealershipRegional: "Regional da Concessionária",
  dealershipLocal: "Local da Concessionária",
  dealershipRepresentative: "Representante da Concessionária",
  dealershipCellNumber: "Telefone da Concessionária",
  dealershipArea: "Área da Concessionária",

  // Campos legados (mantidos para compatibilidade)
  vehicleId: "ID do Veículo",
  vehicleType: "Tipo de Veículo",
  vehicleYear: "Ano do Veículo",
  vehicleSaleDate: "Data de Venda do Veículo",
  vehicleHourmeter: "Horômetro",

  dealershipName: "Nome da Concessionária",
  dealershipUniqueId: "CNPJ da Concessionária",
  dealershipLocation: "Localização da Concessionária",
  dealershipPhone: "Telefone da Concessionária",
  dealershipDemarcatedArea: "Área Demarcada da Concessionária",

  partOrders: "Pedidos de Peças",
  partOrderParts: "Peças",
  partOrder: "Pedido de Peças",
  partOrderDtOrder: "Data do Pedido de Peças",
  partOrderDtEstimate: "Data da Previsão de Entrega",
  partOrderDtDeliveryEstimate: "Data de Entrega da Peça",
  partOrderStatus: "Status Peças",
  partOrderNumber: "Número do Pedido de Peças",
  partOrderStatusOrder: "Status do Pedido de Peças",
  partOrderDeliveryDates: "Datas de Entrega do Pedido de Peças",

  createdBy: "Criado por",
  literatureDiagnosis: "Leitura de Diagnóstico",
  country: "País",
  emissionStandard: "Legislação",
  scheduleNumber: "UUID do Agendamento",
  failureType: "Tipo de Falha",
  failures: "Falhas",
  comment: "Comentário",
};

export const fieldsLabelIds: Record<keyof typeof fieldsLabels, string> = {
  vehicleId: "intl-msg:shared.occurrence.field.vehicleId",
  vehicleChassis: "intl-msg:shared.occurrence.field.vehicleChassis",
  vehicleModel: "intl-msg:shared.occurrence.field.vehicleModel",
  vehicleLicensePlate: "intl-msg:shared.occurrence.field.vehicleLicensePlate",
  vehicleType: "intl-msg:shared.occurrence.field.vehicleType",
  vehicleName: "intl-msg:shared.occurrence.field.vehicleName",
  vehicleYear: "intl-msg:shared.occurrence.field.vehicleYear",
  vehicleSaleDate: "intl-msg:shared.occurrence.field.vehicleSaleDate",
  vehicleOdometer: "intl-msg:shared.occurrence.field.vehicleOdometer",
  vehicleHourmeter: "intl-msg:shared.occurrence.field.vehicleHourmeter",
  vehiclePayloadType: "intl-msg:shared.occurrence.field.vehiclePayloadType",
  vehicleMaximumPayload: "intl-msg:shared.occurrence.field.vehicleMaximumPayload",
  vehicleCriticalPayload: "intl-msg:shared.occurrence.field.vehicleCriticalPayload",
  vehicleStopped: "intl-msg:shared.occurrence.field.vehicleStopped",
  driverName: "intl-msg:shared.occurrence.field.driverName",
  driverLicenseNumber: "intl-msg:shared.occurrence.field.driverLicenseNumber",
  driverPhone: "intl-msg:shared.occurrence.field.driverPhone",
  driverCheckInDriver: "intl-msg:shared.occurrence.field.driverCheckInDriver",
  dealershipName: "intl-msg:shared.occurrence.field.dealershipName",
  dealershipDn: "intl-msg:shared.occurrence.field.dealershipDn",
  dealershipUniqueId: "intl-msg:shared.occurrence.field.dealershipUniqueId",
  dealershipLocation: "intl-msg:shared.occurrence.field.dealershipLocation",
  dealershipRepresentative: "intl-msg:shared.occurrence.field.dealershipRepresentative",
  dealershipRegional: "intl-msg:shared.occurrence.field.dealershipRegional",
  dealershipPhone: "intl-msg:shared.occurrence.field.dealershipPhone",
  dealershipDemarcatedArea: "intl-msg:shared.occurrence.field.dealershipDemarcatedArea",
  partOrders: "intl-msg:shared.occurrence.field.partOrders",
  partOrderParts: "intl-msg:shared.occurrence.field.partOrderParts",
  partOrder: "intl-msg:shared.occurrence.field.partOrder",
  partOrderDtOrder: "intl-msg:shared.occurrence.field.partOrderDtOrder",
  partOrderDtEstimate: "intl-msg:shared.occurrence.field.partOrderDtEstimate",
  partOrderDtDeliveryEstimate: "intl-msg:shared.occurrence.field.partOrderDtDeliveryEstimate",
  partOrderStatus: "intl-msg:shared.occurrence.field.partOrderStatus",
  partOrderNumber: "intl-msg:shared.occurrence.field.partOrderNumber",
  partOrderStatusOrder: "intl-msg:shared.occurrence.field.partOrderStatusOrder",
  partOrderDeliveryDates: "intl-msg:shared.occurrence.field.partOrderDeliveryDates",
  criticality: "intl-msg:shared.occurrence.field.criticality",
  osNumber: "intl-msg:shared.occurrence.field.osNumber",
  osDtOpenAt: "intl-msg:shared.occurrence.field.osDtOpenAt",
  createdBy: "intl-msg:shared.occurrence.field.createdBy",
  literatureDiagnosis: "intl-msg:shared.occurrence.field.literatureDiagnosis",
  literatureTroubleshooting: "intl-msg:shared.occurrence.field.literatureTroubleshooting",
  country: "intl-msg:shared.occurrence.field.country",
  occurrenceType: "intl-msg:shared.occurrence.field.occurrenceType",
  tasNumber: "intl-msg:shared.occurrence.field.tasNumber",
  tasStatus: "intl-msg:shared.occurrence.field.tasStatus",
  timeOpenProtocol: "intl-msg:shared.occurrence.field.timeOpenProtocol",
  source: "intl-msg:shared.occurrence.field.source",
  hasLink: "intl-msg:shared.occurrence.field.hasLink",
  mainOccurrence: "intl-msg:shared.occurrence.field.mainOccurrence",
  estimateTimeRepair: "intl-msg:shared.occurrence.field.estimateTimeRepair",
  solutionProposed: "intl-msg:shared.occurrence.field.solutionProposed",
  mechanicLocation: "intl-msg:shared.occurrence.field.mechanicLocation",
  towTruckLocation: "intl-msg:shared.occurrence.field.towTruckLocation",
  checklist: "intl-msg:shared.occurrence.field.checklist",
  customer: "intl-msg:shared.occurrence.field.customer",
  renter: "intl-msg:shared.occurrence.field.renter",
  emissionStandard: "intl-msg:shared.occurrence.field.emissionStandard",
  protocolNumber: "intl-msg:shared.occurrence.field.protocolNumber",
  scheduleNumber: "intl-msg:shared.occurrence.field.scheduleNumber",
  failureType: "intl-msg:shared.occurrence.field.failureType",
};

export const fieldsWorklogLabelIds: Record<keyof typeof fieldsWorklogLabels, string> = {
  currentStep: "intl-msg:shared.occurrence.field.currentStep",
  criticality: "intl-msg:shared.occurrence.field.criticality",
  osNumber: "intl-msg:shared.occurrence.field.osNumber",
  osDtOpenAt: "intl-msg:shared.occurrence.field.osDtOpenAt",
  renter: "intl-msg:shared.occurrence.field.renter",
  literatureTroubleshooting: "intl-msg:shared.occurrence.field.literatureTroubleshooting",
  occurrenceType: "intl-msg:shared.occurrence.field.occurrenceType",
  tasNumber: "intl-msg:shared.occurrence.field.tasNumber",
  tasStatus: "intl-msg:shared.occurrence.field.tasStatus",
  timeOpenProtocol: "intl-msg:shared.occurrence.field.timeOpenProtocol",
  source: "intl-msg:shared.occurrence.field.source",
  hasLink: "intl-msg:shared.occurrence.field.hasLink",
  observation: "intl-msg:shared.occurrence.field.observation",
  status: "intl-msg:shared.occurrence.field.status",
  mainOccurrence: "intl-msg:shared.occurrence.field.mainOccurrence",
  estimateTimeRepair: "intl-msg:shared.occurrence.field.estimateTimeRepair",
  solutionProposed: "intl-msg:shared.occurrence.field.solutionProposed",
  mechanicLocation: "intl-msg:shared.occurrence.field.mechanicLocation",
  towTruckLocation: "intl-msg:shared.occurrence.field.towTruckLocation",
  checklist: "intl-msg:shared.occurrence.field.checklist",
  customer: "intl-msg:shared.occurrence.field.customer",
  protocolNumber: "intl-msg:shared.occurrence.field.protocolNumber",
  partnerId: "intl-msg:shared.occurrence.field.partnerId",
  hasCampaigns: "intl-msg:shared.occurrence.field.hasCampaigns",
  finalizationReasonType: "intl-msg:shared.occurrence.field.finalizationReasonType",
  finalizationReasonDescription: "intl-msg:shared.occurrence.field.finalizationReasonDescription",
  vehicleChassis: "intl-msg:shared.occurrence.field.vehicleChassis",
  vehicleModel: "intl-msg:shared.occurrence.field.vehicleModel",
  vehicleLicensePlate: "intl-msg:shared.occurrence.field.vehicleLicensePlate",
  vehicleVehicleType: "intl-msg:shared.occurrence.field.vehicleType",
  vehicleName: "intl-msg:shared.occurrence.field.vehicleName",
  vehicleVehicleYear: "intl-msg:shared.occurrence.field.vehicleYear",
  vehicleOdometer: "intl-msg:shared.occurrence.field.vehicleOdometer",
  vehicleHourMeter: "intl-msg:shared.occurrence.field.vehicleHourmeter",
  vehicleEmissionStandard: "intl-msg:shared.occurrence.field.emissionStandard",
  vehiclePayloadType: "intl-msg:shared.occurrence.field.vehiclePayloadType",
  vehicleMaximumPayload: "intl-msg:shared.occurrence.field.vehicleMaximumPayload",
  vehicleCriticalPayload: "intl-msg:shared.occurrence.field.vehicleCriticalPayload",
  vehicleStopped: "intl-msg:shared.occurrence.field.vehicleStopped",
  driverName: "intl-msg:shared.occurrence.field.driverName",
  driverLicenseNumber: "intl-msg:shared.occurrence.field.driverLicenseNumber",
  driverPhone: "intl-msg:shared.occurrence.field.driverPhone",
  driverCheckInDriver: "intl-msg:shared.occurrence.field.driverCheckInDriver",
  dealershipDn: "intl-msg:shared.occurrence.field.dealershipDn",
  dealershipRegional: "intl-msg:shared.occurrence.field.dealershipRegional",
  dealershipLocal: "intl-msg:shared.occurrence.field.dealershipLocal",
  dealershipRepresentative: "intl-msg:shared.occurrence.field.dealershipRepresentative",
  dealershipCellNumber: "intl-msg:shared.occurrence.field.dealershipPhone",
  dealershipArea: "intl-msg:shared.occurrence.field.dealershipArea",
  vehicleId: "intl-msg:shared.occurrence.field.vehicleId",
  vehicleType: "intl-msg:shared.occurrence.field.vehicleType",
  vehicleYear: "intl-msg:shared.occurrence.field.vehicleYear",
  vehicleSaleDate: "intl-msg:shared.occurrence.field.vehicleSaleDate",
  vehicleHourmeter: "intl-msg:shared.occurrence.field.vehicleHourmeter",
  dealershipName: "intl-msg:shared.occurrence.field.dealershipName",
  dealershipUniqueId: "intl-msg:shared.occurrence.field.dealershipUniqueId",
  dealershipLocation: "intl-msg:shared.occurrence.field.dealershipLocation",
  dealershipPhone: "intl-msg:shared.occurrence.field.dealershipPhone",
  dealershipDemarcatedArea: "intl-msg:shared.occurrence.field.dealershipDemarcatedArea",
  partOrders: "intl-msg:shared.occurrence.field.partOrders",
  partOrderParts: "intl-msg:shared.occurrence.field.partOrderParts",
  partOrder: "intl-msg:shared.occurrence.field.partOrder",
  partOrderDtOrder: "intl-msg:shared.occurrence.field.partOrderDtOrder",
  partOrderDtEstimate: "intl-msg:shared.occurrence.field.partOrderDtEstimate",
  partOrderDtDeliveryEstimate: "intl-msg:shared.occurrence.field.partOrderDtDeliveryEstimate",
  partOrderStatus: "intl-msg:shared.occurrence.field.partOrderStatus",
  partOrderNumber: "intl-msg:shared.occurrence.field.partOrderNumber",
  partOrderStatusOrder: "intl-msg:shared.occurrence.field.partOrderStatusOrder",
  partOrderDeliveryDates: "intl-msg:shared.occurrence.field.partOrderDeliveryDates",
  createdBy: "intl-msg:shared.occurrence.field.createdBy",
  literatureDiagnosis: "intl-msg:shared.occurrence.field.literatureDiagnosis",
  country: "intl-msg:shared.occurrence.field.country",
  emissionStandard: "intl-msg:shared.occurrence.field.emissionStandard",
  scheduleNumber: "intl-msg:shared.occurrence.field.scheduleNumber",
  failureType: "intl-msg:shared.occurrence.field.failureType",
  failures: "intl-msg:shared.occurrence.field.failures",
  comment: "intl-msg:shared.occurrence.field.comment",
};

export const formatFieldLabel = (intl: IntlShape, field: string): string => {
  const id = fieldsLabelIds[field as keyof typeof fieldsLabelIds];
  return id ? intl.formatMessage({ id }) : "";
};

export const formatWorklogFieldLabel = (intl: IntlShape, field: string): string => {
  const id = fieldsWorklogLabelIds[field as keyof typeof fieldsWorklogLabelIds];
  return id ? intl.formatMessage({ id }) : field;
};
